import * as yup from 'yup'

/**
 * ✅ DX Best practice (Type safe)
 *
 * Validate env variables with yup
 */
const envSchema = yup.object().shape({
  VITE_API_ENDPOINT: yup.string().url().required(),
  VITE_APP_NAME: yup.string().required(),
})

const validatedEnv = envSchema.validateSync(import.meta.env, {
  abortEarly: false,
  stripUnknown: true,
})

declare global {
  interface ImportMetaEnv extends yup.InferType<typeof envSchema> {}
}

export const config = {
  API_ENDPOINT: validatedEnv.VITE_API_ENDPOINT,
  VITE_APP_NAME: validatedEnv.VITE_APP_NAME,
} as const
